import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={19.429}
      height={19.429}
      viewBox="0 0 19.429 19.429"
      {...props}
    >
      <g
        data-name="Icon feather-save"
        fill="none"
        stroke="#18206b"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path
          data-name="Path 10792"
          d="M16.881 18.929H2.548A2.048 2.048 0 01.5 16.881V2.548A2.048 2.048 0 012.548.5H13.81l5.119 5.119v11.262a2.048 2.048 0 01-2.048 2.048z"
        />
        <path data-name="Path 10793" d="M14.833 18.929v-8.191H4.595v8.191" />
        <path data-name="Path 10794" d="M4.595.5v5.119h8.191" />
      </g>
    </svg>
  )
}

export default SvgComponent
